import { create } from "zustand"
import { devtools, persist } from "zustand/middleware"

interface PdfViewerStore {
	/** Map of contentId -> last active page number */
	activePages: Record<string, number>
	setActivePage: (contentId: string, page: number) => void
	getActivePage: (contentId: string) => number | null
}

export const usePdfViewerStore = create<PdfViewerStore>()(
	devtools(
		persist(
			(set, get) => ({
				activePages: {},
				setActivePage: (contentId: string, page: number) =>
					set(state => ({
						activePages: { ...state.activePages, [contentId]: page },
					})),
				getActivePage: (contentId: string) =>
					get().activePages[contentId] ?? null,
			}),
			{
				name: "pdf-viewer-store",
			}
		),
		{
			name: "PdfViewerStore",
			enabled: process.env.NODE_ENV === "development",
		}
	)
)
